const embedLink = (url) => (
  url.replace('/watch?v=', '/embed/')
)

export default embedLink